// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"55d503d2","483":"b057f614","729":"31d6cfe0","757":"7bf73fb2"}[chunkId] + ".chunk.css";
};